"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logspot = void 0;
var api_1 = require("./api");
var campaign_1 = require("./campaign");
var class_listener_1 = require("./class-listener");
var cookie_1 = require("./cookie");
var dnt_1 = require("./dnt");
var super_properties_1 = require("./super-properties");
var user_1 = require("./user");
var utils_1 = require("./utils");
var DEFAULT_CONFIG = {
    cookiesDisabled: false,
    enableAutoPageviews: true,
    enableAutoClicks: false,
    stickyCampaigns: false,
};
var Logspot = function () {
    var sdkConfig;
    var disableTracking;
    var getPageViewPayload;
    var currentUrl;
    var currentRef;
    var userId;
    var superProperties;
    var campaign;
    var init = function (config) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, width, height, language, _b, hostname, pathname, search, document, screen, cookie, update;
        var _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (typeof window === "undefined") {
                        throw new Error("Logspot - script needs access to window object");
                    }
                    disableTracking = (0, dnt_1.hasExplicitDNT)() || (!!config.enableBrowserDNT && (0, dnt_1.hasBrowserDNT)());
                    if (disableTracking) {
                        return [2 /*return*/];
                    }
                    sdkConfig = __assign(__assign({}, DEFAULT_CONFIG), config);
                    superProperties = new super_properties_1.SuperProperties(sdkConfig);
                    campaign = new campaign_1.Campaign(sdkConfig);
                    _a = window.screen, width = _a.width, height = _a.height, language = window.navigator.language, _b = window.location, hostname = _b.hostname, pathname = _b.pathname, search = _b.search, document = window.document;
                    screen = "".concat(width, "x").concat(height);
                    currentUrl = "".concat(pathname).concat(search);
                    currentRef = document.referrer;
                    if (config.cookiesDisabled || disableTracking) {
                        (0, cookie_1.eraseCookie)(cookie_1.LOGSPOT_COOKIE_ID);
                        userId = (0, user_1.getUid)();
                    }
                    else {
                        cookie = (0, cookie_1.getCookie)(cookie_1.LOGSPOT_COOKIE_ID);
                        userId = cookie !== null && cookie !== void 0 ? cookie : (0, user_1.getUid)();
                        if (!cookie) {
                            (0, cookie_1.setCookie)({
                                name: cookie_1.LOGSPOT_COOKIE_ID,
                                value: userId,
                                expiresInSeconds: (_c = sdkConfig.cookieExpirationInSeconds) !== null && _c !== void 0 ? _c : 2 * cookie_1.ONE_YEAR_IN_SECONDS,
                                domain: (_d = sdkConfig.cookieDomain) !== null && _d !== void 0 ? _d : null,
                            });
                        }
                    }
                    getPageViewPayload = function () {
                        return {
                            hostname: hostname,
                            screen: screen,
                            language: language,
                        };
                    };
                    if (!sdkConfig.onLoad) return [3 /*break*/, 2];
                    return [4 /*yield*/, sdkConfig.onLoad()];
                case 1:
                    _e.sent();
                    _e.label = 2;
                case 2:
                    update = function () {
                        if (document.readyState === "complete") {
                            if (sdkConfig.enableAutoPageviews) {
                                pageview();
                            }
                            var bodyList = document.querySelector("body");
                            var observer = new MutationObserver(function (mutations) {
                                mutations.forEach(function (mutation) {
                                    if (currentUrl != document.location.href) {
                                        var newUrl = document.location.href;
                                        currentRef = currentUrl;
                                        if (newUrl.substring(0, 4) === "http") {
                                            currentUrl = "/" + newUrl.split("/").splice(3).join("/");
                                        }
                                        else {
                                            currentUrl = newUrl;
                                        }
                                        if (currentUrl !== currentRef && sdkConfig.enableAutoPageviews) {
                                            pageview();
                                        }
                                    }
                                });
                            });
                            var config_1 = {
                                childList: true,
                                subtree: true,
                            };
                            observer.observe(bodyList, config_1);
                        }
                    };
                    document.addEventListener("readystatechange", update, true);
                    update();
                    (0, class_listener_1.listenToClassClicks)(function (_a) {
                        var name = _a.name;
                        return track({ event: name, channel: sdkConfig.pageviewsChannel });
                    });
                    if (config.enableAutoClicks) {
                        captureClicks();
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var track = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, _a, propsUserId, props, campaignParams, cleanedUrl;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!sdkConfig || disableTracking) {
                        return [2 /*return*/];
                    }
                    if (!sdkConfig || (!sdkConfig.externalApiUrl && !sdkConfig.publicKey)) {
                        console.error("Logspot - SDK not configured. You need to call: Logspot.init({publicKey: 'YOUR_PUBLIC_KEY'})");
                        return [2 /*return*/];
                    }
                    payload = getPageViewPayload();
                    _a = superProperties.getProperties(), propsUserId = _a.userId, props = __rest(_a, ["userId"]);
                    campaignParams = campaign.getCampagingParams();
                    cleanedUrl = (0, utils_1.removeQueryParamsFromUrl)(currentUrl, campaign_1.CAMPAIGN_KEYWORDS);
                    return [4 /*yield*/, (0, api_1.trackEvent)(sdkConfig, {
                            event: data.event,
                            channel: data.channel,
                            message: data.message,
                            notify: data.notify,
                            userId: (_c = (_b = data.userId) !== null && _b !== void 0 ? _b : (propsUserId ? "".concat(propsUserId) : null)) !== null && _c !== void 0 ? _c : userId,
                            hostname: payload.hostname,
                            language: payload.language,
                            referrer: currentRef,
                            screen: payload.screen,
                            url: cleanedUrl,
                            metadata: __assign(__assign(__assign({}, campaignParams), props), ((_d = data.metadata) !== null && _d !== void 0 ? _d : {})),
                        })];
                case 1:
                    _e.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var pageview = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!sdkConfig || disableTracking) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, track({
                            event: "Pageview",
                            channel: (_a = sdkConfig.pageviewsChannel) !== null && _a !== void 0 ? _a : null,
                            userId: data === null || data === void 0 ? void 0 : data.userId,
                            metadata: data === null || data === void 0 ? void 0 : data.metadata,
                        })];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var captureClicks = function () {
        var onClick = function (event) {
            var _a, _b;
            var target = event.target;
            event.stopPropagation();
            if ((target === null || target === void 0 ? void 0 : target.innerText) && (target === null || target === void 0 ? void 0 : target.innerText) > 500) {
                return;
            }
            var text = (_a = target === null || target === void 0 ? void 0 : target.innerText) === null || _a === void 0 ? void 0 : _a.slice(0, 500).trim();
            track({
                event: "Click",
                channel: (_b = sdkConfig.pageviewsChannel) !== null && _b !== void 0 ? _b : null,
                metadata: {
                    id: target.id,
                    tag: target.tagName,
                    className: target.className,
                    text: text,
                    href: target.href,
                },
            });
        };
        document.addEventListener("click", onClick, false);
    };
    var register = function (properties) {
        if (!sdkConfig || disableTracking) {
            return true;
        }
        return superProperties.register(properties);
    };
    var getProperties = function () {
        if (!sdkConfig || disableTracking) {
            return {};
        }
        return superProperties.getProperties();
    };
    var unregister = function (property) {
        if (!sdkConfig || disableTracking) {
            return;
        }
        superProperties.unregister(property);
    };
    var reset = function () {
        var _a, _b;
        if (!sdkConfig || disableTracking) {
            return;
        }
        (0, cookie_1.eraseCookie)(cookie_1.LOGSPOT_COOKIE_ID);
        superProperties.clear();
        userId = (0, user_1.getUid)();
        if (!sdkConfig.cookiesDisabled && !disableTracking) {
            (0, cookie_1.setCookie)({
                name: cookie_1.LOGSPOT_COOKIE_ID,
                value: userId,
                expiresInSeconds: (_a = sdkConfig.cookieExpirationInSeconds) !== null && _a !== void 0 ? _a : 2 * cookie_1.ONE_YEAR_IN_SECONDS,
                domain: (_b = sdkConfig.cookieDomain) !== null && _b !== void 0 ? _b : null,
            });
        }
    };
    return { init: init, track: track, pageview: pageview, register: register, unregister: unregister, reset: reset, getProperties: getProperties };
};
exports.logspot = Logspot();
exports.default = exports.logspot;
